import { getHttp, postHttp } from "./axios";

function getPushButton(params) {
	return getHttp("/fitting/hiOption/pushButton", params);
}

function setPushButton(data) {
	return postHttp("/fitting/hiOption/pushButton", data);
}

function getVolumeButton(params) {
	return getHttp("/fitting/hiOption/volumeButton", params);
}
function setVolumeButton(data) {
	return postHttp("/fitting/hiOption/volumeButton", data);
}

function getVolumeBehavior(params) {
	return getHttp("/fitting/hiOption/volumeBehavior", params);
}
function setVolumeBehavior(data) {
	return postHttp("/fitting/hiOption/volumeBehavior", data);
}

function getStartUp(params) {
	return getHttp("/fitting/hiOption/startup", params);
}
function setStartUp(params) {
	return postHttp("/fitting/hiOption/startup", params);
}
function getBeep(params) {
	return getHttp("/fitting/hiOption/beep", params);
}
function setBeep(params) {
	return postHttp("/fitting/hiOption/beep", params);
}

export function getCurvedisplay() {
	return getHttp("/fitting/curvedisplay");
}
export function getOptionalCurveTypes() {
	return getHttp("/fitting/curvedisplay/optionalCurveTypes");
}
export function setOptionalCurveTypes(target, extend) {
	return postHttp(
		`/fitting/curvedisplay/optionalCurveTypes?isShowTargetCurves=${target}&isShowExtendedCurves=${extend}`
	);
}

export function setCurveSetting(data) {
	return postHttp("/fitting/curvedisplay", data);
}
export function getRealEarCalibration() {
	return getHttp("/fitting/realEarCalibration");
}

export function getFrequencyBandGroup(side = "both") {
	return getHttp(`/fitting/fineTuning/gainMpo/frequencyBandGroup`);
}
export function setFrequencyBandGroupApi(bands, side = "both") {
	return postHttp(
		`/fitting/fineTuning/gainMpo/frequencyBandGroup?side=${side}&bands=${bands}`
	);
}

export function getAdvanceFrequencyBandGroup(side = "both") {
	return getHttp(`/fitting/fineTuning/advancedSound/frequencyBandGroup`);
}
export function setAdvanceFrequencyBandGroupApi(bands, side = "both") {
	return postHttp(
		`/fitting/fineTuning/advancedSound/frequencyBandGroup?side=${side}&bands=${bands}`
	);
}

export function getAvailableUpdaters(type) {
	return getHttp(
		`/fitting/fineTuning/gainMpo/availableUpdaters?updaterType=${type}`
	);
}
export function getCompressionUpdaters() {
	return getHttp(`/fitting/fineTuning/gainMpo/compressionUpdaters`);
}
export function getBasicInitialFitting() {
	return getHttp(`/fitting/basictuning/initialfitting`);
}
export function setBasicInitialFittingApi(data) {
	return postHttp(`/fitting/basictuning/initialfitting`, data);
}

export function getNoisercalculationstrategy() {
	return getHttp(`/fitting/basictuning/noisercalculationstrategy`);
}
export function setNoisercalculationstrategyApi(data) {
	return postHttp(`/fitting/basictuning/noisercalculationstrategy`, data);
}
export function getSoundRecover() {
	return getHttp(`/fitting/basictuning/soundrecover`);
}
export function setGlobalSoundRecover(v) {
	return postHttp(
		`/fitting/basictuning/soundrecover/showSoundRecoverOptionsInGlobalTuning?side=both&showSoundRecoverOptionsInGlobalTuning=${v}`
	);
}
export function getBassBoost() {
	return getHttp(`fitting/basictuning/bassboost`);
}
export function setBassBoostApi(data) {
	return postHttp(`fitting/basictuning/bassboost`, data);
}

export function getSupportedFittingFormula(side = "both") {
	return getHttp("/fitting/basictuning/initialparameters/supported?side=both");
}
export function getSupportedFittingFormula2() {
	return getHttp("/fitting/basictuning/initialparameters");
}
export function setCurrentFittingFormulaId(v, side = "both") {
	return postHttp(
		`/fitting/basictuning/initialparameters?side=${side}&CurrentfittingFormulaId=${v}`
	);
}

export function getInitialparametersCoupling() {
	return getHttp("/fitting/basictuning/initialparameters/coupling");
}
export function setInitialparametersCoupling(v) {
	return postHttp("/fitting/basictuning/initialparameters?isCoupling=" + v);
}

export function adjustmentWay(data) {
	return postHttp(
		`/fitting/fineTuning/gainMpo/adjustments?side=${data.side}&adjustmentWay=${data.adjustmentWay}&speed=${data.speed}&updaterType=${data.updaterType}`
	);
}
export function checker() {
	return getHttp(`/fitting/detail/reCalculation/Checker`);
}
export function reCalculation() {
	return postHttp(`/fitting/detail/reCalculation`);
}

export function getSelectedUpdaters(side) {
	if (side === "left" || side === "right")
		return getHttp(`/fitting/fineTuning/gainMpo/selectedUpdaters?side=${side}`);
	else return getHttp(`/fitting/fineTuning/gainMpo/selectedUpdaters`);
}
export function setSelectedUpdatersApi(side, type, data) {
	return postHttp(
		`/fitting/fineTuning/gainMpo/selectedUpdaters?side=${side}&updaterType=${type}`,
		data
	);
}

export function addStreamingProgramItems() {
	return getHttp(`/fitting/fineTuning/programManager/addStreamingProgramItems`);
}
export function addCustomProgramItems() {
	return getHttp(`/fitting/fineTuning/programManager/addCustomProgramItems`);
}

export function getFrequencyCompressionCoupling() {
	return getHttp("/fitting/fineTuning/frequencyCompression/v2/coupling");
}
export function setFrequencyCompressionCoupling(v) {
	return postHttp(
		"/fitting/fineTuning/frequencyCompression/v2?isCoupling=" + v
	);
}
export function getFrequencyCompressionInfo(v = "both") {
	return getHttp("/fitting/fineTuning/frequencyCompression/v2/info?side=" + v);
}
export function setFrequencyCompressionEnable(side, v) {
	return postHttp(
		`/fitting/fineTuning/frequencyCompression/v2?side=${side}&isEnabled=${v}`
	);
}
export function setFrequencyCompressionAudibility(side, v) {
	return postHttp(
		`/fitting/fineTuning/frequencyCompression/v2/info?side=${side}&audibility=${v}`
	);
}
export function setFrequencyCompressionClarity(side, v) {
	return postHttp(
		`/fitting/fineTuning/frequencyCompression/v2/info?side=${side}&clarity=${v}`
	);
}

export function getEasingSoftCoupling() {
	return getHttp(`/fitting/fineTuning/easingSoft/coupling`);
}
export function setEasingSoftCoupling(v) {
	return postHttp(`/fitting/fineTuning/easingSoft?isCoupling=${v}`);
}
export function getEasingSoftUpdaters(v) {
	return getHttp(`/fitting/fineTuning/easingSoft/availableUpdaters`);
}

export function getEasingSoftSelectUpdaters(v = "both") {
	return getHttp(`/fitting/fineTuning/easingSoft/selectedUpdaters?side=${v}`);
}
export function setEasingSoftSelectUpdatersApi(side, type, data) {
	return postHttp(
		`/fitting/fineTuning/easingSoft/selectedUpdaters?side=${side}&updaterType=${type}`,
		data
	);
}

export function adjustSoundGains(data) {
	return postHttp(
		`/fitting/fineTuning/easingSoft/adjustments?side=${data.side}&adjustmentWay=${data.adjustmentWay}&speed=${data.speed}&updaterType=${data.updaterType}`
	);
}

export function getFrequencyCompressionCurveInfo() {
	return getHttp(`fitting/curvedisplay/frequencyCompression`);
}

//可听度微调
export function getBothAvailableUpdaters() {
	return getHttp(`fitting/fineTuning/advancedSound/availableUpdaters`);
}

// 精细调节程序列表
export function getAllProgramKeys() {
	return getHttp(`fitting/fineTuning/programManager/allPrograms`);
}
export function selectProgramApi(v) {
	return postHttp(`fitting/fineTuning/programManager?Program=${v}`);
}

export function showOutputOptionalCurve(option = {}) {
	let q = "";
	for (let key in option) {
		q += `&${key}=${option[key]}`;
	}
	q = q.slice(1);
	return postHttp(`fitting/curvedisplay/optionalCurveTypes/output?${q}`);
}
export function showShowFeedback(v) {
	return postHttp(
		`fitting/curvedisplay/optionalCurveTypes/gain?isShowFeedback=${v}`
	);
}
export function setExtendedCurvesOption(v) {
	return postHttp(
		`fitting/curvedisplay/optionalCurveTypes?extendedCurvesOption=${v}`
	);
}

export function programManagerCopy2Left() {
	return postHttp(`fitting/fineTuning/programManager/copyToLeft`);
}
export function programManagerCopy2Right() {
	return postHttp(`fitting/fineTuning/programManager/copyToRight`);
}
export function addSingleProgram(type, category) {
	return postHttp(`fitting/fineTuning/programManager/addSingleProgram`, { ProgramType: type });
}

export default {
	setBeep,
	getPushButton,
	setPushButton,
	getVolumeButton,
	setVolumeButton,
	getVolumeBehavior,
	getStartUp,
	setStartUp,
	getBeep,
	setVolumeBehavior
};
